export const Bowser = require("bowser"),
  browserParser = Bowser.getParser(window.navigator.userAgent),
  browser = browserParser.getBrowserName().toLowerCase(),
  isDev = !document.location.hostname.match(/\./),
  serverURLDev23 = isDev ? 'http://dev23.speakunique.co.uk' : '',
  serverURLLocal = isDev ? 'http://localhost:8005' : '',
  serverURL = serverURLDev23,
  apiServer = isDev ? serverURL : "",
  apiServerURL = apiServer + `ctsnuxdrgybcxhjkef`,
  sentencesURL = serverURL + `/sentences/`,
  submitSampleURL = serverURL + `/add-sample`,
  finishedPingURL = serverURL + `/finished`,
  onRegisterURL = `${process.env.PUBLIC_URL}/service`,
  onRegisterDonorURL = `${process.env.PUBLIC_URL}/go`,
  onSignInURL = `${process.env.PUBLIC_URL}/`,
  abbreviateEmail = email => email.replace(/([^@.+]).+?(?=[@.+])/g, "$1-").replace(/@.+$/, "@"),
  makeOption = (value, label = null) => { return { value, label: label || value }; },
  hide = elId => { const e = document.getElementById(elId); if (e) e.classList.add("is-hidden"); },
  show = elId => { const e = document.getElementById(elId); if (e) e.classList.remove("is-hidden"); },
  unHideNav = () => hideNav(show),
  months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ],
  dobDayOptions = [...Array(31).fill().map((_, i) => i + 1)].map(datum => makeOption(datum)),
  dobMonthOptions = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map(d => makeOption(d, months[d - 1])),
  dobYearOptions = [...Array(84).fill().map((_, i) => i)].map(d => makeOption(new Date().getFullYear() - 16 - d)),
  axiosConfig = { crossDomain: true },
  orange = "#F2936F",
  osDetails = () => {
    let rv = {};
    const attrs = [
      "vendor",
      "hardwareConcurrency",
      "cookieEnabled",
      "appCodeName",
      "appName",
      "appVersion",
      "platform",
      "product",
      "userAgent",
      "language",
      "onLine",
      "doNotTrack"
    ];
    attrs.forEach(attr => (rv[attr] = window.navigator[attr]));
    return rv;
  },
  isBrowser = {
    opera: browser === "opera",
    firefox: browser === "firefox",
    safari: browser === "safari",
    ie: browser === "internet explorer",
    chrome: browser === "chrome",
    pingdom: !!window.navigator.userAgent.match(/pingdom/i)
  },
  hideNav = (cb = hide) => {
    [
      "logoutNavItem",
      "createVoiceNavDiv",
      "downloadVoiceNavDiv",
      "createVoiceNavItem",
      "downloadVoiceNavItem",
      "settingsNavDiv"
    ].forEach(elementID => cb(elementID));
  };

export function copyToClipboard(text) {
  // https://stackoverflow.com/a/33928558/5324657
  if (window.clipboardData && window.clipboardData.setData) {
    // Internet Explorer-specific code path to prevent textarea being shown while dialog is visible.
    return window.clipboardData.setData("Text", text);
  }
  else if (document.queryCommandSupported && document.queryCommandSupported("copy")) {
    let textarea = document.createElement("textarea");
    textarea.textContent = text;
    textarea.style.position = "fixed";  // Prevent scrolling to bottom of page in Microsoft Edge.
    document.body.appendChild(textarea);
    textarea.select();
    try {
      return document.execCommand("copy");  // Security exception may be thrown by some browsers.
    }
    catch (ex) {
      console.error("Copy to clipboard failed", ex);
    }
    finally {
      document.body.removeChild(textarea);
    }
  } else window.alert("No copy command supported by your local browser, sorry.");
}
